//  学习效力
/*
    1.学习策略
    2.人格特性(学习风格)
    3.隐秘图形测试
*/
const Part3Index = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/index.vue');

//1
const LearningEffectivenessGuide1 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesGuide1.vue')
const LearningEffectivenessQues1 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/ques1.vue')
const LearningEffectivenessSuccess1 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesSuccess1.vue')

//2
const LearningEffectivenessGuide21 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesGuide2_1.vue')
const LearningEffectivenessQues21 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/ques2_1.vue')
const LearningEffectivenessSuccess21 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesSuccess2_1.vue')
const LearningEffectivenessGuide22 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesGuide2_2.vue')
const LearningEffectivenessQues22 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/ques2_2.vue')
const LearningEffectivenessSuccess22 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesSuccess2_2.vue')

//3
const LearningEffectivenessGuide3 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesGuide3.vue')
const LearningEffectivenessQues3 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/ques3.vue')
const LearningEffectivenessSuccess3 = () => import('@/views/ceping/LearningAbility/LearningEffectiveness/quesSuccess3.vue')
export default[
    {
        path: '/learningAbility/LearningEffectiveness',
        name: '学习效力首页',
        component:Part3Index,
        meta:{requireAuth:true,roles:['student']},
    },
    //1
    {
        path: '/learningAbility/LearningEffectiveness/guide/1',
        name: 'LearningEffectivenessGuide1',
        component: LearningEffectivenessGuide1,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/1',
        name: 'LearningEffectivenessQues1',
        component: LearningEffectivenessQues1,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/success/1',
        name: 'LearningEffectivenessSuccess1 ',
        component: LearningEffectivenessSuccess1,
        meta:{requireAuth:true,roles:['student']},
    },
    //2
    {
        path: '/learningAbility/LearningEffectiveness/guide/21',
        name: 'LearningEffectivenessGuide2',
        component: LearningEffectivenessGuide21,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/21',
        name: 'LearningEffectivenessQues2',
        component: LearningEffectivenessQues21,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/success/21',
        name: 'LearningEffectivenessSuccess2 ',
        component: LearningEffectivenessSuccess21 ,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/guide/22',
        name: 'LearningEffectivenessGuide22',
        component: LearningEffectivenessGuide22,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/22',
        name: 'LearningEffectivenessQues22',
        component: LearningEffectivenessQues22,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/success/22',
        name: 'LearningEffectivenessSuccess22 ',
        component: LearningEffectivenessSuccess22,
        meta:{requireAuth:true,roles:['student']},
    },
    //3
    {
        path: '/learningAbility/LearningEffectiveness/guide/3',
        name: 'LearningEffectivenessGuide3',
        component: LearningEffectivenessGuide3,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/3',
        name: 'LearningEffectivenessQues3',
        component: LearningEffectivenessQues3,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningEffectiveness/success/3',
        name: 'LearningEffectivenessSuccess3',
        component: LearningEffectivenessSuccess3,
        meta:{requireAuth:true,roles:['student']},
    }
]
